const ThemeActionTypes = {
  CHANGE_THEME_TO_DARK: 'CHANGE_THEME_TO_DARK',
  CHANGE_THEME_TO_LIGHT: 'CHANGE_THEME_TO_LIGHT',
};

export default ThemeActionTypes;
